import { render, staticRenderFns } from "./outsource_list.vue?vue&type=template&id=382a2cc0&scoped=true"
import script from "./outsource_list.vue?vue&type=script&lang=js"
export * from "./outsource_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382a2cc0",
  null
  
)

export default component.exports